import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import Modal from '../../../commonComponents/modal/Modal';
import translate from '../../../commonComponents/translate';
import List from '../../../commonComponents/lists/List';
import { throttle } from '../../../services/utilityFunctions';
import TextFilter from '../../../commonComponents/lists/filters/TextFilter';
import UserColumn from '../../../commonComponents/lists/columns/UserColumn';
import SessionProp from '../propTypes/sessionProp';
import UserProp from '../../../commonComponents/propTypes/userProp';
import SelectFilter from '../../../commonComponents/lists/filters/SelectFilter';
import ParticipationStatus from './Components/ParticipationStatus';

function ShowParticipantsModal({ t, onClose, session, onSelectUserParticipant, shouldSelect }) {
  const userTypeNames = {};
  Object.values(UserProp.TYPES).forEach(userType => {
    userTypeNames[userType] = t(`user_type_${userType}`);
  });
  const optionAny = [{ id: '', text: t('any') }];
  const userTypesFilterList = optionAny.concat([
    { id: UserProp.ROLES.ADMIN, text: t('role_admin') },
    ...Object.keys(userTypeNames).map(userType => ({ id: userType, text: userTypeNames[userType] })),
  ]);

  const [query, setQuery] = useState({ search: '' });
  const [selected, setSelected] = useState([]);
  const selectedRef = useRef([]);
  const tableEl = useRef(null);

  const handleQueryChange = field => value => {
    setSelected([]);
    setQuery(prev => ({ ...prev, [field]: value }));
  };

  const handleUserTypeChange = value => {
    setSelected([]);
    if (value === '') {
      setQuery(prev => ({ ...prev, type: value, role: value }));
    } else if (value === UserProp.ROLES.ADMIN) {
      setQuery(prev => ({ ...prev, type: '', role: value }));
    } else {
      setQuery(prev => ({ ...prev, type: value, role: UserProp.ROLES.USER }));
    }
  };

  /* const renderStatus = status => {
  const r = {
    active: { classTitle: 'dot-active' },
    invited: { classTitle: 'dot-invited' },
  };
  if (!status) {
    return '-';
  }
  return renderToStaticMarkup((
    <div className={r[status].classTitle} />));
}; */

  useEffect(
    () => {
      selectedRef.current = selected;
    },
    [selected],
  );

  const columns = [
    {
      field: 'name',
      title: t('name'),
      textAlign: 'left',
      sortable: false,
      width: 200,
      template: user =>
        renderToStaticMarkup(<UserColumn t={t} user={user} includeWrapper={false} />),
    },
    {
      field: 'participationStatus',
      title: t('session.table.participation.participationStatus'),
      textAlign: 'center',
      sortable: false,
      template: user =>
        renderToStaticMarkup(<ParticipationStatus participationStatus={user.participationStatus} t={t} />),
    },
  ];

  return (
    <Modal onClose={onClose} id="participants-session-modal">
      <div className="modal-dialog modal-dialog-centered modal-lg participants-modal-container" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t('sessionDetails_modal.participants')}</h5>
            <button type="button" onClick={onClose} className="btn-close">
              <span>x</span>
            </button>
          </div>
          <div id="modalBody" className="modal-body participants-modal" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            {
              shouldSelect ? (
                <div className="search-container">
                  <TextFilter
                    onChange={throttle(handleQueryChange('search'), 300)}
                    id="nameFilter"
                    placeholder={t('sessionDetails_modal.search')}
                  />
                </div>
              ) : (
                <div className="m-form m-form--label-align-right">
                  <div className="row align-items-center search-container">
                    <div className="col-lg-8 col-md-6 order-1 order-xl-1">
                      <div className="form-group m-form__group align-items-center">
                        <TextFilter
                          onChange={throttle(handleQueryChange('search'), 300)}
                          id="nameFilter"
                          placeholder={t('sessionDetails_modal.searchParticipants')}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 order-1 order-xl-1">
                      <div className="form-group m-form__group align-items-center">
                        <SelectFilter
                          id="roleFilter"
                          items={userTypesFilterList}
                          onChange={handleUserTypeChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
            <div className="card-connect_extra-members">
                  <List
                    id="participantList"
                    ref={tableEl}
                    dataSourceURL={`/table/access-session/users/list/${session._id}`}
                    dataSourceHeaders={{
                      'Accept-Version': '1.0.0',
                      'X-Gamification-API': 'Games',
                    }}
                    columns={columns}
                    query={query}
                    onRowClick={
                      user => {
                        if (onSelectUserParticipant && shouldSelect) {
                          onSelectUserParticipant(user);
                        }
                      }
                    }
                  />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

ShowParticipantsModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  session: PropTypes.shape(SessionProp.propType).isRequired,
  onSelectUserParticipant: PropTypes.func,
  shouldSelect: PropTypes.bool,
};
ShowParticipantsModal.defaultProps = {
  onClose: () => {},
  onSelectUserParticipant: null,
  shouldSelect: false,
};

export default translate(ShowParticipantsModal);
